// React Components
import React from "react";
import { useEffect } from "react";

// Material UI Components
import Grid from '@mui/material/Grid';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import FormHelperText from "@mui/material/FormHelperText";
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';


// Function to insert our Workload selector (textfield).
export default function WorkloadSelector(props){

    const { tenantId, selectedWorkloads, setSelectedWorkloads, defaultWorkload, errorSelectedWorkloads } = props;

    const workloads = [
        'All',
        'SharePoint',
        'Exchange',
        'Entra ID',
        'Teams',
      ];
      
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            sx: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
            maxWidth: 'calc(100vw - 32px)',
        },
        },
    };

    // Use useEffect to set the default value when defaultWorkload changes
    useEffect(() => {
        if (defaultWorkload && workloads.includes(defaultWorkload)) {
            // Make sure the defaultWorkload is a valid workload option
            setSelectedWorkloads([defaultWorkload]);
        }
    }, [defaultWorkload, setSelectedWorkloads]);


    return(
        
        <Grid item xs={12}>
            {/* Workload input field control. */}
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'minmax(0, 1fr)', sm: '140px minmax(0, 398px)' }, gap: { xs: 1, sm: 0 }, width: '100%' }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <b>Workload:</b>
                </Box>
                <Box sx={{ minWidth: 0 }}>
                <FormControl fullWidth variant="outlined" error={errorSelectedWorkloads}>
                <Select
                labelId="workload-multiple-checkbox-label"
                id="workload-multiple-checkbox"
                multiple
                value={selectedWorkloads}
                onChange={event => setSelectedWorkloads(event.target.value)}                
                renderValue={(selected) => selected.join(', ')}
                MenuProps={MenuProps}
                sx={{ width: '100%' }}
                //error={errorSelectedWorkloads}
                //helperText={errorSelectedWorkloads ? 'You must select at least 1 workload.' : ''}  
                >
                {workloads.map((workload) => (
                    <MenuItem key={workload} value={workload}>
                    <Checkbox checked={selectedWorkloads.indexOf(workload) > -1} />
                    <ListItemText primary={workload} />
                    </MenuItem>
                ))}
                </Select>
                <FormHelperText>{errorSelectedWorkloads ? 'You must select at least 1 workload.' : ''}</FormHelperText>
                </FormControl>
                </Box>
            </Box>
        </Grid>
    );
};
